<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
    ></page-template>
  </div>
</template>
<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import formDialog from "@/components/template/formDialog";
  import api from "@/config/api";

  export default {
    components: {
      formDialog,
      pageTemplate,
    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
              {label: "订单号", prop: "name", type: "input"}
            ],
          complex: [
            {
              label: "日期",
              prop: "startTime",
              type: "dateTimeRangeButton",
              dateType: "datetime",
              span:24
            },
            {
              label: " ",
              prop: "userName",
              type: "radio",
              span:12,
              data: [{label: '今日', value: 1}, {label: '本周', value: 2}, {label: '本月', value: 3}]
            },]

        },
        // 表格信息配置
        tableOptions: {
          columns: [
            {label: "ID", prop: "id", width: "50", align: "center"},
            {
              label: '订单号',
              prop: 'userName',
              width: '100',
              align: 'center'
            },
            {
              label: '日期',
              prop: 'operationType',
              width: '100',
              align: 'center'
            },
            {
              label: '购买商品',
              prop: 'ipAddr',
              width: '100',
              align: 'center'
            },
            {
              label: '购买门店',
              prop: 'operationFunction',
              width: '200',
              align: 'center'
            },
            {
              label: '有效期',
              prop: 'operationFlag',
              width: '100',
              align: 'center'
            },
            {
              label: '金额',
              prop: 'operationDttm',
              width: '100',
              align: 'center'
            },
            {
              label: '操作人',
              prop: 'remarks',
              width: '250',
              align: 'center'
            },
            {
              label: '发票抬头',
              prop: 'remarks',
              width: '250',
              align: 'center'
            },
          ],
          url: api.system.buy
        },
        // 添加字段
      };
    },
    methods: {}
  };
</script>




// WEBPACK FOOTER //
// src/page/system/user/Buy.vue